import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthAdminContext } from "../../clients/utils/AuthAdminContext";
import logo from "../../assets/logo.png";
import loginBg from "../../assets/admin.png"; // image de fond Comores

// Icône œil
const EyeIcon = ({ open }) => open ? (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
) : (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
  </svg>
);

// Icône personne
const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

// Icône cadenas
const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  </svg>
);

export default function LoginAdmin() {
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [view, setView] = useState("login");
  const [username, setUsername] = useState("");
  const [forgotErr, setForgotErr] = useState(null);
  const [forgotLoading, setForgotLoading] = useState(false);

  const navigate = useNavigate();
  const { dispatch } = useContext(AuthAdminContext);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    dispatch({ type: "ADMIN_LOGIN_START" });
    try {
      const res = await axios.post(
        "https://api.komorotel.com/api/authAdmin/login",
        { username: credentials.username, password: credentials.password },
        { withCredentials: true }
      );
      dispatch({ type: "ADMIN_LOGIN_SUCCESS", payload: res.data });
      if (res.data.isBoss) {
        navigate(`/devAdmin/${res.data._id}`);
      } else if (res.data.hotelId) {
        navigate(`/admin/${res.data._id}/${res.data.hotelId}`);
      } else {
        navigate(`/admin/${res.data._id}`);
      }
    } catch (err) {
      setError(err.response?.data);
      dispatch({ type: "ADMIN_LOGIN_ERROR", payload: err.response?.data });
    }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setForgotErr(null);
    setForgotLoading(true);
    try {
      await axios.post("https://api.komorotel.com/api/authAdmin/forgot-password", { username });
      setView("forgot_sent");
    } catch (err) {
      setForgotErr(err.response?.data?.message || "Nom d'utilisateur introuvable.");
    } finally {
      setForgotLoading(false);
    }
  };

  // Style commun des inputs avec icône
  const inputWrap = "relative flex items-center";
  const inputIcon = "absolute left-3.5 text-[#3A9D23] pointer-events-none";
  const inputBase = "w-full pl-11 pr-4 py-3.5 rounded-xl border border-gray-200 bg-white text-sm text-gray-900 placeholder-gray-400 focus:outline-none transition";

  return (
    <div className="min-h-screen flex">

      <style>{`
        @keyframes komoFadeIn { from {opacity:0; transform: translateY(6px);} to {opacity:1; transform:none;} }
        .komo-fade { animation: komoFadeIn .4s ease; }
      `}</style>

      {/* ── PANNEAU GAUCHE ─────────────────────────────── */}
      <div
        className="hidden lg:flex flex-col w-[46%] max-w-[560px] shrink-0 p-12 relative overflow-hidden"
        style={{
          backgroundImage: `url(${loginBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Voile dégradé pour lisibilité */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(180deg, rgba(15,40,10,0.30) 0%, rgba(15,40,10,0.10) 40%, rgba(15,40,10,0.55) 100%)",
          }}
        />

        {/* Logo transparent, calé en haut */}
        <div className="relative z-10">
          <img src={logo} alt="Komorotel" className="h-20 w-auto brightness-0 invert" />
        </div>

        {/* Bloc texte centré verticalement */}
        <div className="relative z-10 flex-1 flex flex-col justify-center max-w-[400px]">
          <p className="text-[#5bbf3f] text-xs font-bold tracking-[0.2em] uppercase mb-4">
            Espace administrateur
          </p>
          <h1
            className="text-white text-[2.4rem] font-bold leading-[1.12]"
            style={{ fontFamily: "Georgia, serif", textShadow: "0 2px 14px rgba(0,0,0,0.4)" }}
          >
            Gérez vos hébergements depuis un seul endroit.
          </h1>
          <p className="text-white/80 text-[15px] mt-5 leading-relaxed" style={{ textShadow: "0 1px 8px rgba(0,0,0,0.4)" }}>
            Réservations, tarifs, disponibilités —<br />tout en temps réel.
          </p>
          {/* Barre verte signature */}
          <div className="mt-7 h-1 w-14 rounded-full" style={{ background: "#3A9D23" }} />
        </div>

        {/* Copyright */}
        <div className="relative z-10">
          <p className="text-white/50 text-xs">© {new Date().getFullYear()} Komorotel</p>
        </div>
      </div>

      {/* ── PANNEAU DROIT ──────────────────────────────── */}
      <div className="flex-1 flex items-center justify-center bg-white p-6">
        <div className="w-full max-w-md">

          {/* Logo mobile uniquement */}
          <div className="lg:hidden flex justify-center mb-8">
            <img src={logo} alt="Komorotel" className="h-14 w-auto" />
          </div>

          {/* ── VUE LOGIN ──────────────────────── */}
          {view === "login" && (
            <div className="komo-fade">
              <h2 className="text-[26px] font-bold text-gray-900 mb-1.5">Connexion</h2>
              <p className="text-sm text-gray-500 mb-9">Accédez à votre espace de gestion.</p>

              <form onSubmit={handleSubmit} noValidate className="space-y-5">
                {/* Username */}
                <div>
                  <label htmlFor="username" className="block text-xs font-bold text-gray-500 mb-2 uppercase tracking-wide">
                    Nom d'utilisateur
                  </label>
                  <div className={inputWrap}>
                    <span className={inputIcon}><UserIcon /></span>
                    <input
                      id="username"
                      type="text"
                      autoComplete="username"
                      required
                      onChange={handleChange}
                      className={inputBase}
                      onFocus={e => e.target.style.boxShadow = "0 0 0 2px #3A9D23"}
                      onBlur={e => e.target.style.boxShadow = "none"}
                      placeholder="votre identifiant"
                    />
                  </div>
                </div>

                {/* Password */}
                <div>
                  <label htmlFor="password" className="block text-xs font-bold text-gray-500 mb-2 uppercase tracking-wide">
                    Mot de passe
                  </label>
                  <div className={inputWrap}>
                    <span className={inputIcon}><LockIcon /></span>
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="current-password"
                      required
                      onChange={handleChange}
                      className={`${inputBase} pr-11`}
                      onFocus={e => e.target.style.boxShadow = "0 0 0 2px #3A9D23"}
                      onBlur={e => e.target.style.boxShadow = "none"}
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(p => !p)}
                      className="absolute right-3.5 text-gray-400 hover:text-gray-600 transition"
                    >
                      <EyeIcon open={showPassword} />
                    </button>
                  </div>
                </div>

                {error && (
                  <div className="flex items-start gap-2.5 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-xl">
                    <span className="mt-0.5">⚠️</span>
                    <span>{error.message || "Identifiants incorrects."}</span>
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full py-3.5 rounded-xl text-white text-[15px] font-semibold transition active:scale-95"
                  style={{ background: "#3A9D23" }}
                  onMouseEnter={e => e.target.style.background = "#2d7c1b"}
                  onMouseLeave={e => e.target.style.background = "#3A9D23"}
                >
                  Se connecter
                </button>

                <div className="text-center pt-1">
                  <button
                    type="button"
                    onClick={() => { setError(null); setView("forgot"); }}
                    className="text-sm text-gray-400 hover:text-gray-600 underline underline-offset-2 transition"
                  >
                    Mot de passe oublié ?
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* ── VUE FORGOT ─────────────────────── */}
          {view === "forgot" && (
            <div className="komo-fade">
              <button
                type="button"
                onClick={() => setView("login")}
                className="flex items-center gap-1.5 text-sm text-gray-400 hover:text-gray-600 mb-6 transition"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Retour
              </button>

              <h2 className="text-[26px] font-bold text-gray-900 mb-1.5">Mot de passe oublié</h2>
              <p className="text-sm text-gray-500 mb-9">
                Entrez votre nom d'utilisateur — un lien sera envoyé à l'email associé.
              </p>

              <form onSubmit={handleForgot} noValidate className="space-y-5">
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-2 uppercase tracking-wide">
                    Nom d'utilisateur
                  </label>
                  <div className={inputWrap}>
                    <span className={inputIcon}><UserIcon /></span>
                    <input
                      type="text"
                      value={username}
                      onChange={e => setUsername(e.target.value)}
                      required
                      className={inputBase}
                      onFocus={e => e.target.style.boxShadow = "0 0 0 2px #3A9D23"}
                      onBlur={e => e.target.style.boxShadow = "none"}
                      placeholder="votre identifiant"
                    />
                  </div>
                </div>

                {forgotErr && (
                  <div className="flex items-start gap-2.5 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-xl">
                    <span>⚠️</span>
                    <span>{forgotErr}</span>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={forgotLoading}
                  className="w-full py-3.5 rounded-xl text-white text-[15px] font-semibold transition disabled:opacity-60 active:scale-95"
                  style={{ background: "#3A9D23" }}
                  onMouseEnter={e => !forgotLoading && (e.target.style.background = "#2d7c1b")}
                  onMouseLeave={e => e.target.style.background = "#3A9D23"}
                >
                  {forgotLoading ? "Envoi en cours…" : "Envoyer le lien"}
                </button>
              </form>
            </div>
          )}

          {/* ── VUE CONFIRMATION ───────────────── */}
          {view === "forgot_sent" && (
            <div className="komo-fade text-center">
              <div
                className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5"
                style={{ background: "#edf7ea" }}
              >
                <svg className="w-7 h-7" style={{ color: "#3A9D23" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>

              <h2 className="text-xl font-bold text-gray-900 mb-2">Email envoyé</h2>
              <p className="text-sm text-gray-500 mb-8 leading-relaxed">
                Si un compte existe avec ce nom d'utilisateur, vous recevrez un lien de réinitialisation sous peu.
              </p>

              <button
                type="button"
                onClick={() => setView("login")}
                className="text-sm underline underline-offset-2 transition"
                style={{ color: "#3A9D23" }}
              >
                ← Retour à la connexion
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}